import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const currencyResolver = z.object({
	Alias: z.string(),
	DisplayName: z.string().nullable(),
	ExRate: z.string(),
	ID: z.string(),
	IsCryptoCurrency: z.boolean(),
	Name: z.string(),
	registration: z.boolean()
});

export type CurrencyModel = z.infer<typeof currencyResolver>;

export const getCurrenciesResult = baseApiResponse.omit({ data: true }).extend({
	data: currencyResolver.array().or(z.record(z.string(), currencyResolver))
});

export type GetCurrenciesResult = z.infer<typeof getCurrenciesResult>;
